export default __webpack_public_path__ + "static/media/landing-photo.16021e34.png";